import Image from 'next/image';
import type {FC} from 'react';
import {
  GTAG_CMD_EVENT,
  GTAG_EVENT_NAMES,
  type GtagLocation,
} from '../../../config/constants/gtag';
import {useGetBannerZ} from '../../../core/repositories/advertisementRepository';
import {CommonLink} from '../CommonLink';

type Props = {
  location: GtagLocation;
  className?: string;
};
export const SpHeaderBanner: FC<Props> = ({location, className}) => {
  const {data} = useGetBannerZ({});

  if (
    !data?.ok ||
    typeof data.value === 'string' ||
    !data.value.imageURL ||
    !data.value.linkURL
  ) {
    return null;
  }

  if (typeof window !== 'undefined') {
    window.gtag(GTAG_CMD_EVENT, GTAG_EVENT_NAMES.IMP_BANNER_Z, {
      banner_z_id: data.value.id,
      location,
    });
  }

  return (
    <CommonLink href={data.value.linkURL} className={className}>
      <Image
        src={data.value.imageURL}
        alt="header banner"
        height={240}
        width={720}
      />
    </CommonLink>
  );
};
